import { render, staticRenderFns } from "./CompetitorBenchmark.vue?vue&type=template&id=ea415142&"
import script from "./CompetitorBenchmark.vue?vue&type=script&lang=js&"
export * from "./CompetitorBenchmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports